<template>
  <div>
    <div class="loading">
      <img src="../assets/img/timg.gif" />
      <!-- <h2>请稍后</h2> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 121;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}
img {
  display: block;
  margin: 5rem auto;
  width: 200px;
  z-index: 999;
}
// h2 {
//   font-size: 100px;
//   text-align: center;
// }
</style>